function Error() {
  return (
    <section className="section">
      <div className="container">
        <div className="has-text-centered">
          <h1 className="title help is-danger">🛑 Ooopps something went wrong 🛑</h1>
        </div>
      </div>
    </section>
  )
}

export default Error